module.exports = __webpack_public_path__ + "img/help.b63405cd.png";